export interface CurrentUserOpts {
    bypassCache: boolean
}
